import { useMemo } from "react";
import useSWR from "swr";

import { formatDecimal } from "@aprosoja/utils";
import { api, fetcher, urls } from "@aprosoja/api";
import { GetStatesData, Option } from "@aprosoja/types";

import { CalculationStepFormValues } from "./schema";
import { useSignUpContext } from "../../../context/sign-up.context";

const useCalculationStepForm = () => {
  const { setSignUpReducer } = useSignUpContext();

  const { data: statesData } = useSWR<GetStatesData>(
    ["/states"],
    async ([url]) => fetcher(url),
    { revalidateOnFocus: false, revalidateOnMount: true }
  );

  const optionsState: Option[] = useMemo(
    () =>
      statesData?.data?.map((state) => ({
        label: state.initials || "",
        value: state.id as string,
      })) || [],
    [statesData?.data]
  );

  const onSubmit = async (values: CalculationStepFormValues) => {
    const arrayAreas = values.properties.map((property) => property.area);

    try {
      let response = await api.post(urls.calculateAnnuity, {
        areas: arrayAreas,
      });

      if (response.status === 200 || response.status === 201) {
        const annualPayment = response.data;
        const monthlyPayment = Number(
          formatDecimal(String(annualPayment / 12)).replace(",", ".")
        );
        setSignUpReducer({
          type: "calculationResults",
          calculationResultsPayload: {
            properties: values.properties,
            annualPayment,
            monthlyPayment,
          },
        });
      }
    } catch (error) {
      console.error("Erro ao calcular anuidade:", error);
    }
  };

  return { onSubmit, optionsState, statesData };
};

export default useCalculationStepForm;
